import React from 'react';
import Svg from '../Svg';

const IconItalic02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2269 2.99978L9.5 2.99978C8.94772 2.99978 8.5 3.4475 8.5 3.99978C8.5 4.55207 8.94772 4.99978 9.5 4.99978L11.807 4.99978L6.557 18.9998H4.5C3.94772 18.9998 3.5 19.4475 3.5 19.9998C3.5 20.5521 3.94772 20.9998 4.5 20.9998H7.22666C7.24215 21.0001 7.25762 21.0001 7.27304 20.9998H10.7267C10.7422 21.0001 10.7576 21.0001 10.773 20.9998H14.5C15.0523 20.9998 15.5 20.5521 15.5 19.9998C15.5 19.4475 15.0523 18.9998 14.5 18.9998H12.193L17.443 4.99978H19.5C20.0523 4.99978 20.5 4.55207 20.5 3.99978C20.5 3.4475 20.0523 2.99978 19.5 2.99978L16.7734 2.99978C16.7579 2.99942 16.7424 2.99942 16.7269 2.99978L13.2734 2.99978C13.2579 2.99942 13.2424 2.99942 13.2269 2.99978ZM15.307 4.99978L13.943 4.99978L8.693 18.9998H10.057L15.307 4.99978Z"
    />
  </Svg>
);

export default IconItalic02;
